export default {
  save: 'Speichern',
  cancel: 'Abbrechen',
  invalid_geometry: 'Ungültige Geometrie',
  confirm_delete: 'Bestätigung des Löschvorgang',
}